import { ScreenSizes } from '@interfaces/index';
import { useTheme } from '@mui/material';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '32px 0px',
      [breakpoints.down(ScreenSizes.Pc)]: {
        padding: '29px 0px',
      },
      [breakpoints.down(ScreenSizes.Tablet)]: {
        padding: '14px 0px 14px',
      },
      [`@media screen and (orientation:landscape)
       and (max-device-height: 760px)
       and (max-device-width: 1180px)`]: {
        padding: '10px 0px',
        zIndex: 1,
      },
      [`@media screen and (orientation:landscape)
       and (max-device-height: 650px)
       and (max-device-width: 1180px)`]: {
        padding: '10px 0px',
        zIndex: 1,
      },
      [`@media screen and (orientation:landscape)
       and (max-device-height: 570px)
       and (max-device-width: 900px)`]: {
        padding: '8px 0px',
        zIndex: 1,
      },
      [`@media only screen and (max-height: 575.98px) and (max-device-width: 750px) and (orientation: landscape)`]:
        {
          padding: '10px 0px',
          zIndex: 1,
        },
    },
    box: {
      flex: 1,
      display: 'flex',
    },
    logo: {
      justifyContent: 'center',
    },
    eventsDropdown: {
      [breakpoints.down(ScreenSizes.Tablet)]: {
        display: 'none',
      },
      '& .MuiInputBase-root': {
        maxWidth: 300,
      },
    },
    menuList: {
      '& .MuiMenuItem-root': {
        maxWidth: 300,
      },
    },
    actionsContainer: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
      justifyContent: 'flex-end',
      '& button': {
        paddingLeft: '30px',
      },
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        '& button': {
          paddingLeft: '20px',
        },
      },
    },
  };
};
